"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Expander = _interopRequireDefault(require("./Expander"));

var _excluded = ["activeIndex", "iconPosition", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Accordion component wraps several Expander components.
 * Each opened Expander will close its already opened siblings.<br/>If you wish to enable more than one Expander open at once, you should just use multiples Expanders
 */
var Accordion = function Accordion(_ref) {
  var activeIndex = _ref.activeIndex,
      iconPosition = _ref.iconPosition,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var accordionRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState(activeIndex || -1),
      stateActive = _React$useState[0],
      setActive = _React$useState[1];

  _react.default.useEffect(function () {
    return setActive(activeIndex);
  }, [activeIndex]);

  var setActiveIndex = function setActiveIndex(i, child) {
    return setActive(i === stateActive ? -1 : i);
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: accordionRef,
    className: (0, _clsx.default)('uk-accordion', className)
  }, attributes), _react.default.Children.map(children, function (child, i) {
    if (! /*#__PURE__*/_react.default.isValidElement(child)) {
      return null;
    }

    if (child.props.expander) {
      return /*#__PURE__*/_react.default.createElement(_Expander.default, {
        key: i,
        trigger: child.props.trigger,
        isOpen: i === stateActive || false,
        onClick: function onClick() {
          return setActiveIndex(i, child);
        },
        iconPosition: iconPosition,
        disabled: child.props.disabled,
        countId: i,
        tag: child.props.tag
      }, child.props.children);
    }

    return /*#__PURE__*/_react.default.cloneElement(child, {
      key: i
    });
  }));
};

Accordion.propTypes = {
  /**
   * Set to open an Expander (0-based index)
   */
  activeIndex: _propTypes.default.number,

  /**
   * Alignment of the +/- within the Expander
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right', 'hide'])
};
Accordion.defaultProps = {
  iconPosition: 'left'
};
var _default = Accordion;
exports.default = _default;